import { Box, Button, Container, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import LinkUnstyled from 'components/@common/LinkUnstyled';

const EmptyScreen = () => {
  return (
    <Container sx={{ pt: 2, flex: 1, display: 'flex' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 1,
          }}
        >
          <FormattedMessage id="account.tickets.empty.title" />
        </Typography>
        <Typography
          variant="small"
          sx={{
            textAlign: 'center',
            mb: 3,
          }}
        >
          <FormattedMessage id="account.tickets.empty.description" />
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          component={LinkUnstyled}
          href={Routes.Home}
        >
          <FormattedMessage id="account.tickets.empty.button" />
        </Button>
      </Box>
    </Container>
  );
};

export default EmptyScreen;
